import React, { Component } from 'react'

export default class FAQ extends Component {
  render() {
    return (
      <main id="maincontent" className="page-main-pal container">
        <div className="page messages">
          <div data-placeholder="messages" />
          <div data-bind="scope: 'messages'">
            {/* ko if: cookieMessages && cookieMessages.length > 0 */}
            {/* /ko */}
            {/* ko if: messages().messages && messages().messages.length > 0 */}
            {/* /ko */}
          </div>
        </div>
        <div className="alocolumns clearfix">
          <div className="column main">
            <input name="form_key" type="hidden" defaultValue="e8QSSxcvECwAqRTn" />
            <div id="authenticationPopup" data-bind="scope:'authenticationPopup', style: {display: 'none'}" style={{ display: 'none' }}>
              {/* ko template: getTemplate() */}
              {/* /ko */}
            </div>
            <div className="page-title">
              <h1>AED Training</h1>
            </div>

            <div className="alocolumns clearfix"><div>
              {/* banner */}
              <div className="section-element row">
                <div className="col-sm-12 col-md-12 header-top-right mobile-slide">
                  <div className="home-slider" data-slides-to-show={1} data-slides-to-scroll={1} data-fade="false" data-dots="true" data-arrows="false" data-easing="linear" data-autoplay-speed={6000} data-speed={400} data-autoplay="true">
                    <div className="item">
                      <a href="#training1">
                        <img className="img-responsive-normal" src="./image/zoll-aed-training-1.jpg" alt="ZOLL AED Training" />
                      </a>
                    </div>
                    <div className="item">
                      <a href="#training2">
                        <img className="img-responsive-normal" src="./image/zoll-aed-training-2.jpg" alt="ZOLL AED Training 2" />
                      </a>
                    </div>
                    <div className="item">
                      <a href="#training3">
                        <img className="img-responsive-normal" src="./image/zoll-aed-training-3.jpg" alt="ZOLL AED Training 3" />
                      </a>
                    </div>
                    <div className="item">
                      <a href="#training4">
                        <img className="img-responsive-normal" src="./image/zoll-aed-training-4.jpg" alt="ZOLL AED Training 4" />
                      </a>
                    </div>
                    <div className="item">
                      <a href="#training5">
                        <img className="img-responsive-normal" src="./image/zoll-aed-training-5.jpg" alt="ZOLL AED Training 5" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>

            <p style={{ display: 'inline !important' }}>
              Keselamatan adalah prioritas utama dalam situasi darurat jantung mendadak. Oleh karena itu, kami tidak hanya menyediakan Automated External Defibrillator (AED) berkualitas tinggi dari ZOLL, tetapi juga menawarkan pelatihan penggunaan AED secara profesional bagi pelanggan kami. Dengan pelatihan ini, Anda akan memiliki pemahaman yang lebih baik dalam menangani kondisi darurat dan menyelamatkan nyawa.
            </p>
            <h2>
              <strong>Ketentuan Pelatihan AED </strong>
            </h2>
            <p>
              Untuk memastikan pelanggan kami mendapatkan manfaat maksimal dari perangkat AED yang mereka beli, kami menyediakan pelatihan dengan ketentuan sebagai berikut:
            </p>
            <ol>
              <li> <strong>Pembelian ZOLL AED dari Kami</strong>
                <p>
                  Pelatihan ini hanya tersedia bagi pelanggan yang telah membeli AED merek ZOLL melalui perusahaan kami.
                  Dengan demikian, pelanggan akan mendapatkan pemahaman yang tepat tentang penggunaan AED yang mereka miliki.</p>
              </li>
              <li> <strong>Pelatihan Gratis di Wilayah Jabodetabek</strong>
                <p>
                  Kami memberikan pelatihan gratis bagi pelanggan yang berada di area Jakarta, Bogor, Depok, Tangerang, dan Bekasi (Jabodetabek).Pelatihan dilakukan oleh tenaga profesional yang berpengalaman dalam penggunaan AED dan tindakan pertolongan pertama.
                </p>
              </li>
            </ol>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
          </div>
        </div>
      </main>

    )
  }
}
